import { render, staticRenderFns } from "./EventResources.vue?vue&type=template&id=65d0ca20&scoped=true&"
import script from "./EventResources.vue?vue&type=script&lang=js&"
export * from "./EventResources.vue?vue&type=script&lang=js&"
import style0 from "./EventResources.vue?vue&type=style&index=0&id=65d0ca20&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65d0ca20",
  null
  
)

export default component.exports